import styled from "styled-components";

const Chip = styled.span<{ color?: string; backgroundColor?: string }>`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? backgroundColor : theme.colors.white};
  color: ${({ color, theme }) => (color ? color : theme.colors.green[900])};
  border: 1px solid
    ${({ color, theme }) => (color ? color : theme.colors.green[900])};
  padding: 2px 6px;
  border-radius: 20px;
  margin: 0 4px;
`;

export { Chip };
